<!--
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2024-07-17 11:34:51
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2024-08-14 09:44:39
 * @FilePath: \hxt-saas-pc\src\views\Management_evaluation\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="box">
        <Header navbar="hearKnowledge"></Header>




        <div class="cpgl">
            <div class="header">
                <div @click="goTo" style="width: 70px;height: 100%;cursor: pointer;margin-left: 40px;">
                    <i class="el-icon-arrow-left"></i>
                    <span>返回</span>
                </div>
                <div class="cpgl-title">{{ name }}</div>

            </div>
            <div class="cpCcon">
                <div class="con1">
                    <div class="sm" v-if="examStartTime || examEndTime">
                        <img style="height: 20px;width: 20px;margin-left: 15px;float: left;margin-top: 10px;margin-right: 10px;"
                            src="../../assets/img/icon1.png" alt="">
                        说明：该时间为测评卷的开放时间，非考试作答时长，学员将在该时间段内自主选择进入测评，错过该结束时间后将无法再进入！
                    </div>
                    <div class="kfTime" v-if="examStartTime || examEndTime">
                        测评卷开放时间 &nbsp;&nbsp;&nbsp;
                        （可设定时间范围
                        <span>
                            <span style="color: #FF9645;">{{ examStartTime ? examStartTime : '' }}</span>

                            <span v-if="examStartTime || examEndTime"> 至 </span>
                            <span style="color: #FF9645;">{{ examEndTime ? examEndTime : '' }}</span>
                        </span>）
                    </div>
                    <div class="TimeL">
                        <div class="block">
                            <div class="demonstration">开始日期 <span style="color: red;">*</span></div>
                            <el-date-picker clear-icon class="picker1" v-model="startTime" type="datetime"
                                placeholder="选择日期时间" align="right" @change="handleDateChange">
                            </el-date-picker>

                        </div>
                        <div class="block">
                            <div class="demonstration">结束日期 <span style="color: red;">*</span></div>
                            <el-date-picker class="picker2" v-model="endTime" type="datetime" placeholder="选择日期时间"
                                align="right" @change="handleDateChange1">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="xxList">
                        &nbsp;&nbsp;&nbsp; 学员列表：
                    </div>
                    <div class="userNum">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 企业学员列表共 &nbsp;<span>{{ memberList1.length }}</span> 人 &nbsp;
                        &nbsp;已选择
                        &nbsp;<span>{{ checkedCities.length }}</span> 人 &nbsp;&nbsp;&nbsp;备注: (置灰状态) 已参与该测评卷作答，不可移除

                    </div>
                    <div class="search">
                        <div class="searchBtn"> <el-input style="height: 41px;" placeholder="请输入内容" v-model="input">

                            </el-input><el-button @click="searchList" type="primary" icon="el-icon-search">搜索</el-button>
                        </div>
                        <div class="qx"> <el-checkbox :indeterminate="isIndeterminate" v-model="checked" @change="SelectAll

                        ">全选</el-checkbox></div>
                    </div>
                    <div class="userList">

                        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                            <div class="userList_li" v-for="city in memberList" :key="city.userId">
                                <el-checkbox :label="city.userId" :key="city.checked" :v-model="city.checked"
                                    :disabled="city.enableRemove == false ? true : false">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {{
                                        city.userName
                                    }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
    city.mobile }}</el-checkbox>
                            </div>
                        </el-checkbox-group>



                    </div>
                    <div class="save">
                        <div @click="save" class="bc">保存</div>
                        <div @click="goTo" class="qx">取消</div>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>

import Header from "@/components/Header.vue";


import {
    examDetail,
    updateExam
} from "@/api/index.js";

export default {

    name: "Management_evaluation",
    components: {
        Header,
    },
    data() {
        return {
            searchIs: false,
            checkedCities: [],
            isIndeterminate: false,
            checked: false,
            input: '',
            endTime: null,
            startTime: null,
            deptId: null,
            token: null,
            id: null,
            name: null,
            examStartTime: null,
            examEndTime: null,
            name1: "",
            memberList1: [

            ],

            memberList: [

            ]

        };
    },
    created() {


        var token = window.localStorage.getItem('token');
        var dept = window.localStorage.getItem('TopDeptId');
        if (token) {


            this.token = token;
        }
        if (dept) {
            this.deptId = dept;
        }

        this.id = this.$route.params.id
        this.name = this.$route.params.name

        this.getexamDetail()

    },
    computed: {


    },
    mounted() {


    },
    methods: {
        searchList() {
            if (this.input) {
                this.searchIs = true
                this.memberList = this.filteredItems()

            } else {
                this.searchIs = false
                this.memberList = this.memberList1
            }

        },
        filteredItems() {
            return this.memberList1.filter(item => item.userName.includes(this.input) || item.mobile.includes(this.input));
        },
        handleCheckedCitiesChange(value) {
            this.setUserId(value)

            this.checkedCities = value
            let checkedCount = value.length;
            if (this.searchIs) {
                this.checked = checkedCount === this.memberList1.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.memberList1.length;
            }
            else {
                this.checked = checkedCount === this.memberList.length; this.isIndeterminate = checkedCount > 0 && checkedCount < this.memberList.length;
            }


        },
        SelectAll(val) {
            if (val == true) {
                this.checkedCities = this.memberList.map(item => item.userId)

            } else {
                var idList = this.memberList.filter((item, index) => { return item.enableRemove == false && item.checked == true })

                this.checkedCities = idList.length ? idList.map(item => item.userId) : []
            }

            this.isIndeterminate = false;
        },
        goTo() {
            this.$router.go(-1)

        },
        getexamDetail() {
            examDetail({
                examDeptId: this.id
            }, { Authorization: this.token }).then(res => {
                if (res.code == 200) {
                    console.log(res)
                    this.name1 = res.data.title
                    this.memberList = res.data.memberList
                    this.memberList1 = res.data.memberList
                    var list = this.memberList.filter(item => { return item.checked == true })
                    this.checkedCities = list.map(item => item.userId)
                    if (list.length == this.memberList1.length) {
                        this.checked = true
                    } else if (list.length) {
                        this.isIndeterminate = true
                    }
                    this.startTime = res.data.startTime
                    this.endTime = res.data.endTime
                    if (res.data.timeLimit == 1) {
                        this.examStartTime = res.data.examStartTime
                        this.examEndTime = res.data.examEndTime
                    }

                }

            })
        },

        handleDateChange(value) {
            if (this.endTime) {

                if (value.getTime() >= new Date(this.endTime).getTime()) {

                    this.$message.error('开始日期不能大于或者等于结束日期');
                    this.startTime = ''; // 重置日期为初始值
                }
            }
            if (this.examStartTime) {
                if (value.getTime() > new Date(this.examEndTime).getTime()) {
                    this.$message.error('开始日期不能大于 ' + this.examEndTime);
                    this.startTime = ''; // 重置日期为初始值
                }
                if (value.getTime() < new Date(this.examStartTime).getTime()) {
                    this.$message.error('开始日期不能小于 ' + this.examStartTime);
                    this.startTime = ''; // 重置日期为初始值
                }
            }

        },
        handleDateChange1(value) {
            if (this.startTime) {
                if (value.getTime() <= new Date(this.startTime).getTime()) {

                    this.$message.error('结束日期不能小于或者等于开始日期');
                    this.endTime = ''; // 重置日期为初始值
                }
            }

            if (this.examEndTime) {
                if (value.getTime() > new Date(this.examEndTime).getTime()) {
                    this.$message.error('结束日期不能大于 ' + this.examEndTime);
                    this.endTime = ''; // 重置日期为初始值
                }

                if (value.getTime() < new Date(this.examStartTime).getTime()) {
                    this.$message.error('结束日期不能小于 ' + this.examStartTime);
                    this.endTime = ''; // 重置日期为初始值
                }
            }




        },
        save() {
            if (!this.startTime) {
                this.$message.error('请选择开始时间');
                return
            }
            if (!this.endTime) {
                this.$message.error('请选择结束时间');
                return
            }
            if (!this.checkedCities.length) {
                this.$message.error('请选择学员');
                return
            }
            //  console.log(this.formatterDate(this.endTime),
            //     this.formatterDate(this.startTime), this.checkedCities)
            var idList = this.checkedCities
            if (this.searchIs) {
                var lits1 = [...this.memberList1.filter(item => item.checked).map(item => item.userId), ... this.checkedCities]
                idList = Array.from(new Set(lits1));
            }
            // console.log(idList)

            updateExam({
                "examDeptId": this.id, //测评主键id
                "userIdList": idList, //用户id列表
                "startTime": this.formatterDate(this.startTime), //开始时间
                "endTime": this.formatterDate(this.endTime)//结束时间
            }, {
                Authorization: this.token
            }).then(res => {
                if (res.code == 200) {
                    this.$message.success('保存成功')
                    this.startTime = ''
                    this.endTime = ''
                    this.checkedCities = []
                    this.getexamDetail()
                    this.goTo()
                } else {
                    this.$message.error(res.msg)
                }

            })


        },
        formatterDate(time) {
            var date = new Date(time)
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? '0' + m : m
            var d = date.getDate()
            d = d < 10 ? '0' + d : d
            var h = date.getHours()
            h = h < 10 ? '0' + h : h
            var minute = date.getMinutes()
            minute = minute < 10 ? '0' + minute : minute
            var s = date.getSeconds()
            s = s < 10 ? '0' + s : s
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s

        },

        setUserId(data) {

            this.memberList1.forEach(item => {
                if (item.enableRemove !== false) {
                    if (data.includes(item.id)) {

                        item.checked = true;
                    } else {

                        item.checked = false;
                    }
                }

            })


        }

    }

};
</script>

<style scoped lang="less">
.box {
    width: 100%;
    overflow-y: auto;
    height: auto;
}

.cpgl {
    padding-top: 100px;
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;

    .header {
        margin-top: 10px;
        width: 1200px;
        height: 68px;
        line-height: 68px;
        font-size: 20px;
        background: #FFFFFF;
        border-radius: 8px;
        display: flex;
        border: 1px solid #F0F0F3;

        .cpgl-title {
            margin-left: 20px;
            width: 700px;

            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .cpCcon {
        margin-top: 10px;
        width: 1200px;
        min-height: 650px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #F0F0F3;

        .con1 {
            width: 1100px;
            min-height: 650px;

            margin: 20px auto;

            .sm {
                width: 1000px;
                background: #EEEEEE;
                color: #0F6CF5;
                border-radius: 15px;
                height: 40px;
                line-height: 40px;


                font-size: 16px;
            }

            .kfTime {
                height: 70px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 22px;
                color: #333333;
                line-height: 70px;
                text-align: left;
                font-style: normal;
            }

            .TimeL {
                display: flex;
                margin-top: 20px;

                .demonstration {
                    height: 30px;
                    line-height: 30px;
                }

                .picker1 {
                    margin-right: 40px;
                }

                .picker1,
                .picker2 {
                    width: 450px;
                }
            }

            .xxList {
                margin-top: 20px;
                width: 100%;
                height: 24px;
                line-height: 24px;
                border-left: 4px solid #3E63EE;
                font-weight: 600;
                font-size: 22px;
                color: #333333;
            }

            .userNum {
                margin-top: 20px;
                height: 30px;
                line-height: 30px;
                font-size: 18px;


                span {
                    color: #FF9645;
                }
            }

            .search {
                width: 100%;
                height: 70px;
                margin-top: 20px;
                display: flex;

                .searchBtn {
                    width: 500px;
                    display: flex;
                    height: 41px;


                    button {
                        height: 41px;
                    }


                }

                .qx {
                    color: #3333;
                    margin-left: 450px;
                    width: 134px;
                    height: 41px;
                    background: #EEEEEE;
                    border-radius: 6px;
                    line-height: 41px;
                    text-align: center;
                }


            }

            .userList {
                width: 100%;
                max-height: 400px;
                overflow: hidden;
                overflow-y: auto;

                .userList_li {
                    height: 50px;

                    border-bottom: 1px solid #F0F0F0;

                    .el-checkbox {
                        width: 100% !important;
                        height: 50px !important;
                        line-height: 50px !important;



                    }


                }

                // .userList_li:last-child {
                //     border: none;
                // }
            }

            .save {
                display: flex;
                width: 300px;

                height: 50px;
                justify-content: space-between;
                margin: 40px auto;

                .bc {
                    cursor: pointer;
                    text-align: center;
                    line-height: 44px;
                    width: 108px;
                    color: #fff;
                    height: 44px;
                    background: #3E63EE;
                    border-radius: 6px;
                }

                .qx {
                    cursor: pointer;
                    text-align: center;
                    line-height: 44px;
                    width: 108px;
                    height: 44px;
                    color: #4F79ED;
                    border-radius: 6px;
                    border: 1px solid #4F79ED;
                }
            }
        }
    }
}

.el-input>.el-input-group__append {
    background: red !important;
}
</style>